import template from "./setup_company_account.html";
import en from "./en.json";
import es from "./es.json";
import _ from "lodash";
import { loadStripe } from "@stripe/stripe-js";
import logoUrl from "../../../../../assets/harvust-logo-008.svg";
import { cloudinaryLogoPictureConfig } from "../../../common/common.services";

const US_STATES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
];

const SETUP_FEE_DISPLAY_BY_ID = {
    no_setup_fee: "$0",
    price_1NlaUlJyMAWYyNscBj0Bw7PS: "$1,000",
    price_1RBhUdJyMAWYyNscR5DvM9q8: "$1,250",
    price_1TNIqkJyMAWYyNscirDkEDIk: "$1,500",
    price_1Sf4nFJyMAWYyNscw3tKncn5: "$1,875",
    price_1RoryDJyMAWYyNscwmrz4ikM: "$2,000",
    price_1SxVGIJyMAWYyNsc4oNzezgF: "$2,250",
    price_1MW64JJyMAWYyNscOZR8ZARb: "$2,500",
    price_1RoryWJyMAWYyNsc5hbsaceS: "$3,000",
    price_1RoryqJyMAWYyNscnpLuRR5W: "$3,500",
    price_1Rorz6JyMAWYyNscmx5chq9P: "$4,000",
    price_1RorzMJyMAWYyNscPnkaI2i9: "$4,500",
    price_1Qn34OJyMAWYyNscQzBlRJ87: "$5,000",
};

class SetupCompanyAccountController {
    /* @ngInject */
    constructor(
        SetupOrderService,
        ToastService,
        $window,
        $timeout,
        $q,
        $document,
        CloudinaryUploadService,
    ) {
        this.SetupOrderService = SetupOrderService;
        this.ToastService = ToastService;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$document = $document;
        this.CloudinaryUploadService = CloudinaryUploadService;
        this.stateOptions = US_STATES;
        this.loadingPaymentElement = true;
        this.cardComplete = false;
        this.cardError = null;
        this.formErrors = {};
        this.nonFieldErrors = null;
        this.saving = false;
        this.LOGO_URL = logoUrl;
        this.stripe = null;
        this.elements = null;
        this.cardElement = null;
    }

    $onInit() {
        let ctrl = this;
        ctrl.form = {};
        ctrl.initStripe();
    }

    $onDestroy() {
        let ctrl = this;
        if (ctrl.cardElement) {
            ctrl.cardElement.unmount();
        }
    }

    initStripe() {
        let ctrl = this;
        ctrl.$timeout(function () {
            ctrl.$q
                .when(loadStripe(process.env.STRIPE_PUBLISHABLE_KEY))
                .then(function (stripe) {
                    ctrl.stripe = stripe;
                    if (!ctrl.stripe) {
                        ctrl.loadingPaymentElement = false;
                        return;
                    }
                    ctrl.elements = ctrl.stripe.elements();
                    ctrl.cardElement = ctrl.elements.create("card");
                    ctrl.cardElement.on("change", function (event) {
                        ctrl.$timeout(function () {
                            ctrl.cardComplete = event.complete;
                            ctrl.cardError = _.get(
                                event,
                                "error.message",
                                null,
                            );
                        });
                    });
                    ctrl.loadingPaymentElement = false;
                    ctrl.$timeout(function () {
                        let mountPoint = ctrl.$document[0].getElementById(
                            "setup-order-card-element",
                        );
                        if (mountPoint) {
                            ctrl.cardElement.mount(mountPoint);
                        }
                    });
                })
                .catch(function () {
                    ctrl.loadingPaymentElement = false;
                    ctrl.ToastService.create(
                        "setupCompanyAccount.PAYMENT_LOAD_FAILURE_TOAST",
                    );
                });
        });
    }

    canSubmit() {
        let ctrl = this;
        if (ctrl.saving) {
            return false;
        }
        if (ctrl.loadingPaymentElement || !ctrl.cardComplete) {
            return false;
        }
        return true;
    }

    createStripePaymentMethod() {
        let ctrl = this;
        if (!ctrl.cardComplete) {
            return ctrl.$q.reject({
                message: "setupCompanyAccount.PAYMENT_METHOD_REQUIRED_ERROR",
            });
        }
        if (!ctrl.stripe || !ctrl.cardElement) {
            return ctrl.$q.reject({
                message: "setupCompanyAccount.PAYMENT_LOAD_FAILURE_TOAST",
            });
        }
        let billingName = _.trim(
            _.join([ctrl.form.first_name, ctrl.form.last_name], " "),
        );
        return ctrl.$q
            .when(
                ctrl.stripe.createPaymentMethod({
                    type: "card",
                    card: ctrl.cardElement,
                    billing_details: {
                        name: billingName,
                        email: ctrl.form.email,
                        phone: ctrl.form.business_phone,
                    },
                }),
            )
            .then(function (result) {
                if (result.error) {
                    return ctrl.$q.reject(result.error);
                }
                return result.paymentMethod.id;
            });
    }

    buildPayload(stripePaymentMethodId) {
        let ctrl = this;
        let payload = {};
        let formPayload = {
            first_name: ctrl.form.first_name,
            last_name: ctrl.form.last_name,
            email: ctrl.form.email,
            business_name: ctrl.form.business_name,
            ein: ctrl.form.ein,
            business_phone: ctrl.form.business_phone,
            business_website: ctrl.form.business_website,
            street_address: ctrl.form.street_address,
            city: ctrl.form.city,
            state: ctrl.form.state,
            zipcode: ctrl.form.zipcode,
        };

        _.forEach(formPayload, function (value, key) {
            if (!_.isNil(value) && value !== "") {
                payload[key] = value;
            }
        });

        if (ctrl.form.logo_id) {
            payload.logo_id = ctrl.form.logo_id;
        }

        if (stripePaymentMethodId) {
            payload.stripe_payment_method = stripePaymentMethodId;
        }

        return payload;
    }

    getSetupFeeDisplayValue() {
        let ctrl = this;
        let setupFeeId = _.get(ctrl.setupOrder, "setup_fee");
        return SETUP_FEE_DISPLAY_BY_ID[setupFeeId] || setupFeeId || "-";
    }

    save(setupCompanyAccountForm) {
        let ctrl = this;
        ctrl.formErrors = {};
        ctrl.nonFieldErrors = null;

        if (setupCompanyAccountForm.$invalid) {
            return;
        }

        ctrl.saving = true;
        ctrl.createStripePaymentMethod()
            .then(function (paymentMethodId) {
                let payload = ctrl.buildPayload(paymentMethodId);
                return ctrl.SetupOrderService.submit(
                    ctrl.setupOrder.sid,
                    payload,
                );
            })
            .then(function (response) {
                if (response.redirect_url) {
                    ctrl.$window.location.href = response.redirect_url;
                    return;
                }
                ctrl.ToastService.create(
                    "setupCompanyAccount.SUBMIT_FAILURE_TOAST",
                );
            })
            .catch(function (reason) {
                ctrl.formErrors = _.get(reason, "data", {});
                ctrl.nonFieldErrors = _.get(
                    reason,
                    "data.non_field_errors",
                    null,
                );
                let detail = _.get(reason, "data.detail");
                if (detail) {
                    ctrl.nonFieldErrors = [detail];
                }
                if (
                    reason.message &&
                    reason.message.indexOf("setupCompanyAccount") === 0
                ) {
                    ctrl.ToastService.create(reason.message);
                } else {
                    ctrl.cardError = reason.message;
                    ctrl.ToastService.create(
                        "setupCompanyAccount.SUBMIT_FAILURE_TOAST",
                    );
                }
            })
            .finally(function () {
                ctrl.saving = false;
            });
    }

    uploadLogo() {
        let ctrl = this;
        return ctrl.CloudinaryUploadService.openUpload(
            cloudinaryLogoPictureConfig,
        ).then(
            function (result) {
                ctrl.form.logo_id = _.get(result, "info.public_id");
                ctrl.ToastService.create(
                    "setupCompanyAccount.LOGO_UPLOAD_SUCCESS_TOAST",
                );
            },
            function () {
                ctrl.ToastService.create(
                    "setupCompanyAccount.LOGO_UPLOAD_FAILURE_TOAST",
                );
            },
        );
    }
}

export default {
    bindings: {
        setupOrder: "<",
    },
    controller: SetupCompanyAccountController,
    template: template,
    name: "setupCompanyAccount",
    translations: { en, es },
};
